// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** C 端查询门店详情 用户扫码门店二维码进入后，通过门店 ID 获取门店基本信息（地址、服务时间、封面等） GET /api/v1/app/stores/${param0} */
export async function AppStoreControllerDetailV1(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: MyApi.AppStoreControllerDetailV1Params,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<MyApi.ApiResponseOutputClientStoreDto>(
    `/api/v1/app/stores/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}
